import React from 'react';
import { faNoteSticky } from '@fortawesome/pro-solid-svg-icons/faNoteSticky';
import { useSelector } from 'react-redux';

import NoteIcon from '../../../components/columns/notes-column/note-icon';
import Global from '../../../store/global-selectors';

import { messages } from './messages';

const getNote = (ret) => {
  if (!ret || !ret.note) {
    return;
  }
  return {
    message: ret.note,
    createdDateTime: ret.createdDateTime,
  };
};

const ReturnNoteColumn = ({ fulfillmentId }) => {
  const ret = useSelector((state) => Global.selectEntitiesReturnById(state, { fulfillmentId }));
  return <NoteIcon disableEdit icon={faNoteSticky} note={getNote(ret)} titleTranslation={messages.returnNoteTitle} />;
};

export const ReturnNote = {
  getMessageDescriptor: () => messages.returnNote,
  id: 'return-note',

  render: ({ fulfillmentId }) => {
    return <ReturnNoteColumn fulfillmentId={fulfillmentId} />;
  },
};
